var _defs, _path, _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpack509({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}.b{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:0.5px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M6.14,11.46l1.06-.12a.76.76,0,0,0,.2.48.6.6,0,0,0,.44.16.74.74,0,0,0,.58-.31,2.65,2.65,0,0,0,.3-1.3,1.3,1.3,0,0,1-1,.48,1.55,1.55,0,0,1-1.17-.52A1.89,1.89,0,0,1,6,9a1.89,1.89,0,0,1,.52-1.4A1.73,1.73,0,0,1,7.87,7a1.76,1.76,0,0,1,1.42.68,3.41,3.41,0,0,1,.56,2.21,3.51,3.51,0,0,1-.58,2.27,1.88,1.88,0,0,1-1.51.69,1.61,1.61,0,0,1-1.09-.35A1.73,1.73,0,0,1,6.14,11.46Zm2.48-2.4a1.25,1.25,0,0,0-.24-.82.71.71,0,0,0-.57-.3.62.62,0,0,0-.5.24,1.21,1.21,0,0,0-.2.79,1.21,1.21,0,0,0,.22.81.65.65,0,0,0,.54.26.69.69,0,0,0,.54-.25A1.1,1.1,0,0,0,8.62,9.06Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "7.78 0.75 0.28 15.24 15.28 15.24 7.78 0.75"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpack509);
export default __webpack_public_path__ + "static/media/Symbolpack_5_09.6399117b8d08165e2d3492c0efff878a.svg";
export { ForwardRef as ReactComponent };